import { Card } from "@/components/Card/card";
import {
  StatCard,
  StatCardHighlight,
  StatCardPrimaryValue,
  StatCardSecondaryValue,
  StatCardTitle,
  StatCardValueContainer,
} from "@/components/Card/StatCard";
import Icon from "@/components/Icon/Icon";
import { Grid, VStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";

import type { ImportCsvError } from "../../types";

type Props = {
  error: ImportCsvError;
  unit: string;
  summaryErrorMessage?: string;
};

const Summary = ({ error, unit, summaryErrorMessage }: Props) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.importCsv.alertCard",
  });

  if (
    error.rowsCount === 0 &&
    error.cellsCount === 0 &&
    error.headerErrors.length === 0
  ) {
    return null;
  }

  return (
    <Grid columns={3} columnGap={24}>
      <Card className="w-full border-error-border bg-error-muted-fill p-4 text-error-on-muted-fill">
        <VStack className="gap-1.5">
          <Icon iconName="AlertCircle" colorVariant="error" />
          <div className="text-sm font-semibold">
            {summaryErrorMessage ?? t("message")}
          </div>
        </VStack>
      </Card>

      {error.rowsCount > 0 && (
        <StatCard className="w-full border-error-border px-6 py-4 text-error-on-neutral-fill">
          <StatCardTitle>Error</StatCardTitle>
          <StatCardHighlight className="h-auto place-items-start">
            <StatCardValueContainer>
              <StatCardPrimaryValue>{error.cellsCount}</StatCardPrimaryValue>
              <StatCardSecondaryValue>{t("cells")}</StatCardSecondaryValue>
              <StatCardPrimaryValue>{error.rowsCount}</StatCardPrimaryValue>
              <StatCardSecondaryValue>{unit}</StatCardSecondaryValue>
            </StatCardValueContainer>
          </StatCardHighlight>
        </StatCard>
      )}

      {error.headerErrors.length > 0 && (
        <Card className="w-full border-error-border bg-error-muted-fill p-4 text-error-on-muted-fill">
          <VStack className="gap-1.5">
            <Icon iconName="AlertCircle" colorVariant="error" />
            <div className="whitespace-pre-wrap text-sm font-semibold">
              {error.headerErrors.join("\n")}
            </div>
          </VStack>
        </Card>
      )}
    </Grid>
  );
};

export default Summary;
